import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthResponseModel } from '../../Models/Authentication/AuthResponse';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';

import { ModelService } from '../../Services/model.service';
import { SocialLoginService } from '../../Services/social-login.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

declare var AppleID: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],standalone:false
})
export class LoginComponent extends BaseComponent { 
  loginForm: FormGroup;
  errorMessage = '';
  showPassword: boolean = false;
  loading:boolean=false;
  authResponse!:AuthResponseModel;
  contacts: any[] = [];
  selectedContact:any
  platform:string='';
  appleloading:boolean=false
  googleLaoding:boolean=false;
  constructor
    (
    private authService: AuthService,
    private router: Router,
    private api:BaseApiService,
    private messageService:ModelService,
    private appleauth:SocialLoginService,
    )
  {
    super();
    this.appleauth.Getplarform().then(x=>{
           this.platform= x
    });
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(8)])
    });
  }
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }


  //Custom Login
  login() {
    if (this.loginForm.valid) {
      this.loading = true;
      this.api.create("Auth/login", this.loginForm.value)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        }
        )
      )
      .subscribe(
        {
             next:async (response) => {
              this.loading = false;
              this.authResponse = response;
              if (this.authResponse.token !== null) {
                const token = this.authResponse.token;
                await this.authService.saveToken(token); 
                this.router.navigate(['/ManueDash']);
              } else {
                this.loading = false;
                this.messageService.showErrorAlert(this.authResponse.message);
              }
            },
            error: (error) => {
              this.loading = false;
              this.messageService.showErrorAlert(error);
            }
        }
        
       
      );
    } else {
      this.loading=false
      this.loginForm.markAllAsTouched();
    }
  }
  
 // Mobile Implemention Apple
  async LoginWithAppleFromIOS(e:Event) 
  {
    try {
      e.preventDefault();
      const user = await this.appleauth.LoginWithAppleNative();
      const email =user.email|| "N/A";
      const userid=user.userId|| "N/A";
      this.AppleServerSideLoginRequest(email,userid);
    } catch (error) 
    {
      this.appleloading=false;
      this.messageService.showErrorAlert("Serveur en panne");
    }
  }

  //Mobile Implemention Google
  async LoginWithGoogleFromIOS(e:Event) 
  {
    try 
   {
      e.preventDefault();
      const user = await this.appleauth.googleloginmobile();
      this.WebBasedLoginRequest(user,"Google");
    } catch (error) 
    {
      this.googleLaoding=false;
      this.messageService.showErrorAlert("Serveur en panne");
    }
  }

  AppleServerSideLoginRequest(email:string,password:string) 
  {
      this.appleloading=true;
      this.api.create("Auth/LoginApple",{email:email,password:password})
      .pipe
      (
        takeUntil(this.destroy$),
        finalize(() => {
          this.appleloading = false;
        }
        )
      )
      .subscribe(
        {
           next:  async (response) => {
            this.appleloading = false;
            this.authResponse = response;
            if (this.authResponse.token !== null) {
              const token = this.authResponse.token;
              await this.authService.saveToken(token); 
              this.router.navigate(['/ManueDash']);
              this.appleloading=false;
            } else {
              this.appleloading=false;
              this.messageService.showErrorAlert(this.authResponse.message);
            }
          },
          error:( error) => {
            this.appleloading=false;
            this.messageService.showErrorAlert(error);
          }
        }

      );
  }

  //Web Implemention
  async LoginWithAppleForWebPlatForm(e:Event) 
  {
    try {
      e.preventDefault();
      this.appleloading=true;
      const user = await this.appleauth.appleSignInWeb();
      if(user.user!=null)
      {
        const email=user.user.email || "N/A";
        this.WebBasedLoginRequest(email,"Apple");
      }
    } catch (error) 
    {
      this.appleloading=false;
      this.messageService.showErrorAlert("Serveur en panne");
    }
  }
  async LoginWithGoogleForWebPlatForm(e:Event) 
  {
    try 
   {
      e.preventDefault();
      const user = await this.appleauth.googleSignInWeb();
      if(user.user!=null){
        const email=user.user.email || "N/A";
        this.WebBasedLoginRequest(email,"Google");
      }
    } catch (error) 
    {
      this.messageService.showErrorAlert("Serveur en panne");
    }
  }
  WebBasedLoginRequest(email:string,password:string) 
  {
      this.googleLaoding=true;
      this.appleloading = true;
      this.api.create("Auth/LoginWeb",{email:email,password:password})
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.googleLaoding = false;
        }
        )
      )
      .subscribe(
        {
          next: async (response) => {
            this.loading = false;
            this.authResponse = response;
            if (this.authResponse.token !== null) {
              const token = this.authResponse.token;
              await this.authService.saveToken(token); 
              this.router.navigate(['/ManueDash']);
              this.googleLaoding =false;
              this.appleloading  =false;
            } else {
              this.googleLaoding=false;
              this.appleloading =false;
              this.messageService.showErrorAlert(this.authResponse.message);
            }
          },
          error:( error) => {
            this.googleLaoding=false;
            this.appleloading =false;
            this.messageService.showErrorAlert(error);
          }
        }
      );
  }

}
